import { ValidationError, FormValidator } from 'core-lib';
import { FileListModel } from '../components/file-upload/file-upload.component';

export class ApplicationDetailsViewModel {

    constructor() {
        this.errors = [];
        this.vehicles = [];
        this.totalCost = 0;
        this.permitFee = 0;
        this.usageFee = 0;
        this.isSameAddress = false;
    }

    public isLoading: boolean;
    public isOpening: boolean;
    public isSubmitted: boolean;

    public clientName: string;
    public firstName: string;
    public lastName: string;
    public abn: string;

    public isSameAddress: boolean;

    public addressSearch: string;
    public isAddressNotFound: boolean;
    public address1: string;
    public address2: string;
    public suburb: string;
    public state: string;
    public postCode: string;

    public billingAddressSearch: string;
    public isBillingAddressNotFound: boolean;
    public billingAddress1: string;
    public billingAddress2: string;
    public billingSuburb: string;
    public billingState: string;
    public billingPostCode: string;
    
    public email: string;
    public mobilePhone: string;
    public workPhone: string;

    public businessTypeId: string;
    public businessTypeOther: string;

    public isEmsKey: boolean;
    public startDate: any;

    public permitFee: number;
    public usageFee: number;
    public totalCost: number;

    public isTCRead: boolean;

    public businessTypes: ApplicationBusinessTypeItem[];
    public vehicleTypes: ApplicationVehicleTypeItem[];
    public vehicleMakes: ApplicationVehicleMakeItem[];

    public errors: ValidationError[];

    public vehicles: ApplicationVehicleViewModel[];
}

export class ApplicationVehicleViewModel {
    constructor() {
        this.errors = [];
        this.fileList = new FileListModel();
    }

    public vehicleId: string;
    public regoNo: string;
    public state: string;
    public capacity: number;
    public vehicleTypeId: string;
    public vehicleMakeId: string;
    public isBackflowPreventionDeviceSetup: boolean;
    public isBackflowPreventionDeviceCertified: boolean;
    public backflowPreventionCertificateIssueDate: any;
    public isRPZD: boolean;
    public isAirGap: boolean;
    public errors: ValidationError[];

    public fileList: FileListModel;
}

export class ApplicationBusinessTypeItem {
    public businessTypeId: string;
    public description: string;
    public status: string;
}

export class ApplicationVehicleMakeItem {
    public vehicleMakeId: string;
    public description: string;
    public status: string;
}

export class ApplicationVehicleTypeItem {
    public vehicleTypeId: string;
    public description: string;
    public status: string;
}